import { render } from "./IconLink.vue?vue&type=template&id=41b63b69"
const script = {}

import exportComponent from "/var/www/vacation-system/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconLink.vue"]])

export default __exports__